import { render } from "./DescAiCrateView.vue?vue&type=template&id=6a3b74a4"
import script from "./DescAiCrateView.vue?vue&type=script&lang=js"
export * from "./DescAiCrateView.vue?vue&type=script&lang=js"

import "./DescAiCrateView.vue?vue&type=style&index=0&id=6a3b74a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__